import ImageZoom from 'js-image-zoom';
import ReplacerImage from "../class/product/ReplacerImage.js";
import Add2CartControls from "../modules/add2cart_controls.js"
//import Swiper from "swiper";
/**
 * Функции, относящиеся к товару (добавление в корзину, изменение, удаление, переключение единиц измерения...).
 */
export default {
    init,
    //initStyledCounter,
    handleMiniCart,
    resetCountProductsOnPage,
};

// Инициализация
function init(yandexMetrikaId) {

    // -------------------------------
    // Инициализация калькулятора краски
    // -------------------------------
    initCalculatorKraski()

    // -------------------------------
    // При фокусе по полю с количеством товара содержимое поля должно очищаться. При сбросе фокуса - восстанавливаться. Как на Петровиче.
    // -------------------------------
    $(document).on('focus', '.custom-counter__amount', function (e) {
        let $target = $(e.target);
        if ($target.val() !== '') {
            $target[0]['lastVal'] = $target.val();
            $target.val('');
        }
    });

    $(document).on('blur', '.custom-counter__amount', function (e) {
        let $target = $(e.target);

        if (typeof e.target['lastVal'] !== 'undefined' && $target.val() === '') {
            $target.val(e.target['lastVal']);
        }
    });


    // -------------------------------
    // Запретить дергать слайды за кнопку добавления товара в корзину / перехода в корзину
    // -------------------------------
    // Если быстро добавлять разные товары в корзину в слайдере, то можно случайно сделать небольшой свайп (немного дергнуть слайд). Из-за этого клик не сработает, и товар не добавится. Данный код исправляет это. Этот баг касается не только кнопки добавления товара в корзину, но и других элементов управления
    $('.swiper-slide .js-product__controls, .swiper-slide .product-card__volume, .swiper-slide .product-card__actions').on('pointerdown touchstart', function (event) {
        event.stopPropagation();
    });


    // -------------------------------
    // Выполнение цели Яндекс.Метрики при добавлении товара в корзину
    // -------------------------------
    // $(document).on('click', '.js-product__to-cart', function () {
    //     if (typeof ym !== 'undefined') {
    //         ym(yandexMetrikaId, 'reachGoal', 'korzina');
    //     }
    //     console.log('korzina');
    // });


    


    // -------------------------------
    // Перелинковка толщина
    // -------------------------------
    if($('#perelinkovka_2345').length){
        $('#perelinkovka_2345').on('change',function(){
            window.location.href = $(this).val();
        })
    }


    // -------------------------------
    // Приближение фотки при наведении на странице товара
    // -------------------------------
    let $zoomImg = $('.zoom-here');
    if ($zoomImg.length) {
        $zoomImg.each(function (index, elem) {
            let $e = $(elem);

            $e.css('background-image', 'url("' + $e.find('img').attr('src') + '")');
            $e.mousemove(function (e) {
                let zoomer = e.currentTarget;
                let offsetX, offsetY;
                let x, y = null;

                if (e.offsetX) {
                    offsetX = e.offsetX;
                    x = offsetX / zoomer.offsetWidth * 100;
                }

                if (e.offsetY) {
                    offsetY = e.offsetY;
                    y = offsetY / zoomer.offsetHeight * 100;
                }

                if (x !== null && y !== null) {
                    zoomer.style.backgroundPosition = x + '% ' + y + '%';
                    zoomer.style.backgroundSize = 200 + '%';
                }
            });
        });
    }

    let ImageZoomInstance;

    const settingsDefault = {
        width: 260,
        height: 260,
        zoomWidth: 500,
        offset: {vertical: 0, horizontal: 10}
    };

    const zoomDefault = document.getElementsByClassName("zoom-default");
    const zoomNarrow = document.getElementsByClassName("zoom-narrow");

    if (zoomDefault.length) {
        ImageZoomInstance = new ImageZoom(zoomDefault[0], settingsDefault);
    } else if (zoomNarrow.length) {
        let settingsNarrow = settingsDefault;
        settingsNarrow['zoomWidth'] = 430;
        ImageZoomInstance = new ImageZoom(zoomNarrow[0], settingsNarrow);
    }


    // -------------------------------
    // Код для страницы с перелинковкой для фанеры и плит ОСБ
    // -------------------------------
    // TODO: Будет красивее, если рассчитывать цену, вес и кол-во товара для м2 на back-end. Загружалось бы сразу с нужным количеством, а не менялось на глазах от JS.
    // let $proFaneraCard = $('.product-card_type_relinking-btns');
    // if ($proFaneraCard.length) {
    //     let $productItem = $('.product-card__content .js-product');
    //
    //     $productItem.on('changeAmount', changeAmountHandler);
    //     changeAmountHandler();
    //
    //     function changeAmountHandler() {
    //         let $activeForm = functions.getActiveForm($productItem);
    //         let amount = $activeForm.action.find('.custom-counter__amount').val();
    //
    //         // Установка цены
    //         let price = $productItem.find('.js-product__price').attr('data-default');
    //         let priceNewVal = Number(amount * price).toFixed(2);
    //         $('.product-card__price-val_type_total').text(functions.numberWithSpaces(priceNewVal));
    //
    //         if ($productItem.hasClass('js-product_with-discount')) {
    //             let newPrice = $productItem.find('.js-product__new-price').attr('data-default');
    //             let newPriceNewVal = Number(amount * newPrice).toFixed(2);
    //             $('.product-card__new-price').text(functions.numberWithSpaces(newPriceNewVal));
    //         }
    //
    //         // Установка веса
    //         let weight = $('.js-product__weight').attr('content');
    //         if (weight > 0) {
    //             let newWeight = Number(amount * weight).toFixed(2);
    //             $('.product-card__weight-val').text(functions.numberWithSpaces(newWeight));
    //         }
    //     }
    //
    //     // Если товар есть в корзине, значит, у него может быть не "1" в кол-ве, а другое число. Поэтому надо пересчитать и второе кол-во
    //     if ($proFaneraCard.find('.js-product-in-cart')) {
    //         let $amountList = $('.custom-counter__amount[data-purpose="second"]');
    //         $amountList.val(($amountList.val() * $amountList.attr('data-koeff')).toFixed(2));
    //     }
    // }


    // -------------------------------------
    // Щелчок по якорю "Отзывы"
    // -------------------------------------
    // $('.product-card__reviews-quantity').on('click', function (e) {
    //     e.preventDefault();
    //
    //     $('.product-card__tabs-button_type_reviews').trigger('click');
    //
    //     $([document.documentElement, document.body]).animate({
    //         scrollTop: $(".product-card__tabs").offset().top
    //     }, 300);
    // });


    if(typeof window.cartControls === 'undefined'){
        window.cartControls = new Add2CartControls();
        window.cartControls.bindHandlers();
    }


    // -------------------------------------
    // Пересчет "В листе" при изменении кол-ва товара в карточке товара для фанеры
    // -------------------------------------
    // let $prod = $('.pro-fanera .product-card__top');
    // if ($prod.length) {
    //     function changeTextDependingOnAmount($prod) {
    //         let m2 = $('.product-card__specs-list-item[data-opt-key="ploshad_m2"] .product-card__specs-list-item-value').text();
    //         let m3 = $('.product-card__specs-list-item[data-opt-key="obyem_m3"] .product-card__specs-list-item-value').text();
    //
    //         let amount = functions.getActiveForm($prod)['action'].find('.custom-counter__amount').val();
    //         m2 *= amount;
    //         m3 *= amount;
    //
    //         if (m2) {
    //             m2 += ' м2';
    //         }
    //
    //         if (m3) {
    //             m3 += ' м3';
    //         }
    //
    //         let val;
    //         if (amount == 1) {
    //             val = 'В листе: ';
    //         } else {
    //             val = 'В ' + amount + ' ' + functions.formOfWord(amount, 'листе', 'листах', 'листах') + ': ';
    //         }
    //         val += [m2, m3].join(', ');
    //
    //         $('.product-card__package').text(val).show();
    //     }
    //
    //     changeTextDependingOnAmount($prod);
    //
    //     $prod.on('changeAmount', function () {
    //         changeTextDependingOnAmount($(this));
    //     });
    // }



    // -------------------------------------
    // Обработчики Minishop2
    // -------------------------------------
    // Добавление товара в корзину. Вызывается при добавлении товара в корзину с карточки товара и со страницы товара
    miniShop2.Callbacks.Cart.add.response.success = function (response) {
        if (response.success) {
            if (typeof ym !== 'undefined' && $('body').is('.gazosilikatstroy, .alterteplo')) {
                ym(window.ymid, 'reachGoal', 'korzina');
                console.log('Достигнута цель: korzina, id счетчика: ' + window.ymid);
            }

            // Работа с мини-корзиной
            handleMiniCart(response.data.unique_products);
        }
    };

    // Удаление товара из корзины. Вызывается при нажатии на крестик на странице корзины
    miniShop2.Callbacks.Cart.remove.response.success = function (response) {
        if (response.success) {
            // Работа с мини-корзиной
            handleMiniCart(response.data.unique_products);
            checkCart(response.data.unique_products);
        }
    };

    // Изменение товара в корзине. Вызывается при изменении кол-ва товара на странице корзины
    miniShop2.Callbacks.Cart.change.response.success = function (response) {
        if (response.success) {
            // Работа с мини-корзиной
            handleMiniCart(response.data.unique_products);
            checkCart(response.data.unique_products);
        }
    };

    // -------------------------------------
    // Работа со страницей товара
    // -------------------------------------
    if ($('.product-card').length) {
        // Вкладки на мобилках
        // Расставляем data-tab-page. Он нужен для кода в base.js. Это не только для мобилок, но и для ПК. Важно делать это через JS, т.к. некоторые вкладки могут не выводиться. А index должен быть по порядку
        $('.product-card__tabs-button').each(function (i, e) {
            $(this).attr('data-tab-page', i);
        });

        // Обработчик кнопок для смены вкладок
        $('.product-card__mobile-tabs-button').on('click', function (e) {
            e.preventDefault();
            let $this = $(this);
            let $tabsPage = $this.closest('.product-card__tabs-page');

            $('.product-card__tabs-page.active').removeClass('active');
            $this.closest('.product-card__tabs-page').addClass('active');

            let index = $tabsPage.index() + 1;
            $('.product-card__tabs-button.active').removeClass('active');
            $('.product-card__tabs-button:nth-child(' + index + ')').addClass('active');
        });
    }


    // -------------------------------------
    // Мини-корзина в шапке сайта
    // -------------------------------------
    handleMiniCart();


    // -------------------------------------
    // Галерея
    // -------------------------------------
    // let $galleryItem = $('.product-card__gallery-item');
    // let $gallerySlider = $('.product-card__gallery-slider');
    //
    // if ($gallerySlider.length) {
    //     $galleryItem.on('click', function (e) {
    //         e.preventDefault();
    //
    //         // Основные переменные
    //         let $this = $(this);
    //         let srcBig = $this.attr('href');
    //         let srcSmall = $this.find('.product-card__gallery-item-img').attr('src');
    //
    //         // Меняем элемент с классом active
    //         $this.parent().find('.active').removeClass('active');
    //         $this.addClass('active');
    //         // Меняем картинку (href - для всплывашки, src - для избражения)
    //         $('.product-card__img-link').attr('href', srcBig);
    //         $('.product-card__img').attr('src', srcSmall);
    //
    //         // Поскольку картинка сменилась, нужно обновить скрипт для увеличения при наведении
    //         if (typeof ImageZoomInstance !== 'undefined') {
    //             ImageZoomInstance.setup();
    //         }
    //         // А еще обновить самописный скрипт
    //         if ($zoomImg.length) {
    //             $zoomImg.css('background-image', 'url("' + $zoomImg.find('img').attr('src') + '")');
    //         }
    //     });
    //
    //     // Если шаблон с перелинковкой, то вешаем обработчик для показа / скрытия стрелок в слайдере галереи
    //     if ($('.product-card_type_relinking').length) {
    //         $(window).on('resize', onResizeHandler);
    //         onResizeHandler();
    //
    //         function onResizeHandler() {
    //             if (window.innerWidth > 480) {
    //                 let commonSlidesHeight = 0;
    //                 let mb = parseFloat($galleryItem.css('margin-bottom'));
    //                 let $btnsWrap = $('.product-card__gallery-btns-wrap');
    //
    //                 // Я сделал новый jQuery селектор, чтобы удобнее было отлаживать (так можно через devtools добавлять слайды). После отладки можно заменить селектор на $galleryItem
    //                 $('.product-card__gallery-item').each(function (i, e) {
    //                     commonSlidesHeight += $(e).outerHeight(true);
    //                 });
    //
    //                 // Вычитаем один margin-bottom, т.к. Swiper добавляет его даже для последнего элемента
    //                 commonSlidesHeight -= mb;
    //                 // Отнимаем несколько пикселей, чтобы стрелки не появлялись, если карточки чуть-чуть не вмещаются
    //                 commonSlidesHeight -= 10;
    //
    //                 if ($gallerySlider.height() < commonSlidesHeight) {
    //                     $btnsWrap.show();
    //                 } else {
    //                     $btnsWrap.hide();
    //                 }
    //             }
    //         }
    //     }
    // }

    // -------------------------------------
    // Переключение вкладок на странице товара
    // -------------------------------------
    let $productInfoblocks = $('.product__infoblocks');
    if ($productInfoblocks.length) {
        $productInfoblocks.find('.infoblocks__container').on('change-tab', function () {
            if (window.innerWidth <= 479) {
                $("html, body").animate({
                    scrollTop: $productInfoblocks.find('.infoblocks__content').offset().top - $('.header__bottom').outerHeight() - 30
                }, 400);
            }
        });
    }

    // Скролл до вкладки "Отызвы"
    let $reviewsTab = $('.infoblocks__tab[data-tab="Отзывы"]');
    if ($reviewsTab.length) {
        $('.rating__reviews_clickable').on('click', function () {
            if (!$reviewsTab.hasClass('active')) {
                $reviewsTab[0].click();
            }
            $('html, body').animate({scrollTop: $('.infoblocks__content').offset().top - $('.header__bottom').outerHeight() - 20}, 300);
        });
    }

    // Всплывашка на цене со скидкой
    if ($('.js-product_with-discount').length) {
        let timeout = setTimeout(function () {
            $('.product-info__price').removeClass('active');
        }, 7000);
        $('.js-product_with-discount .product-info__price-value, .js-product_with-discount .product-info__price-mes-close').on('click', function (e) {
            e.stopPropagation();
            clearTimeout(timeout);
            $(this).closest('.product-info__price').toggleClass('active');
        });
    }

    // Всплывашка на цене со скидкой
    (async function(){
        try{
            if(!document.querySelector('.js-product.js-product_with-discount .tooltip'))return;
            const {PvaTooltip} = await import(/* webpackChunkName: "dynamics_1" */  "../modules/pvaTooltip");
            const prodTooltip = new PvaTooltip('.js-product.js-product_with-discount .tooltip');
            prodTooltip.bind();
        }catch(t){
            //console.error(t);
        }
    })();

    // -------------------------------------------
    // Яндекс.Метрика — цель на клик по "Перейти в калькулятор" в баннере онлайн-калькулятор кровли
    // -------------------------------------------
    $(document).on('click', 'roof-calc-banner__btn', function () {
        if (typeof ym === "function") {
            ym(96715167,'reachGoal','perekhod-so-skvoznogo-bloka-na-kalkulyator-iz-kartochek-tovara');
        }
    });
}


/**
 * Сбросить кол-во товара в 0 у всех товаров на странице.
 */
function resetCountProductsOnPage() {
    $('.js-product-in-cart').each(function (e) {
        let $e = $(this);
        $e.removeClass('js-product-in-cart');
        $e.find('.js-product__controls_action_change .custom-counter__amount').val(0);
        $e.find('.js-product__controls_action_add .custom-counter__amount').val(1);
        $e.find('.js-product__form-add input[name="count"]').val(0);
        $e.find('.js-product__form-change input[name="count"]').val(0);
    });
}



/**
 * Если товаров в корзине 0. И если мы на странице корзины, то перезагружаем страницу.
 */
function checkCart(unique_products) {
    if (unique_products == 0 && $('.cart.section').length) {
        location.reload();
    }
}


/**
 * Работа с миникорзиной в шапке сайта (изменить кол-во, скрыть номерок, если товаров 0, показать номерок в противном случае).
 */
function handleMiniCart(unique_products) {
    const $cartInfoCountVal = $('.header__action_type_minicart');

    // Кол-во товаров в корзине
    let cartValue;
    if (typeof unique_products !== 'undefined') {
        if (unique_products > 0) {
            cartValue = Number((unique_products).toFixed(2));
            $cartInfoCountVal.attr('data-amount', cartValue);
        } else {
            $cartInfoCountVal.removeAttr('data-amount');
        }
    }
}


function initCalculatorKraski(){
    $('.calc-input input').keypress(function(e) {
        if(e.which==43 || e.which==45) return false;
        if(e.which!=48 && e.which!=49 && e.which!=50 && e.which!=51 && e.which!=52 && e.which!=53 && e.which!=54 && e.which!=55 && e.which!=56 && e.which!=57 && e.which!=46 && e.which!=44) return false;
    });

    function isInteger(num) {
        return (num ^ 0) === num;
    }

    $('.js-submit-calc').click(function(){
        var calc = $(this).closest('.wrap-calc'),
            block_result = calc.find('.js-result-calc'),
            block_error = calc.find('.js-error-calc'),
            length = calc.find('#length').val().replace(',','.'),
            width = calc.find('#width').val().replace(',','.'),
            length1 = calc.find('#length1').val().replace(',','.'),
            width1 = calc.find('#width1').val().replace(',','.'),
            rashod = calc.find('#rashod').val().replace(',','.'),
            layout = calc.find('#layout').val().replace(',','.'),
            volume = calc.find('#volume').val().replace(',','.'),
            add = calc.find('input[name="add"]:checked').val(),
            coeff = 0,
            sq = 0, sq_ex = 0, count_paint = 0, error = '', result = '';

        block_error.html('');
        calc.find('input').removeClass('error');

        if(!length){
            error += '<div>Заполните поле Длина</div>';
            calc.find('#length').addClass('error');
        }
        if(!width){
            error += '<div>Заполните поле Ширина</div>';
            calc.find('#width').addClass('error');
        }
        if(!rashod){
            error += '<div>Заполните поле Расход</div>';
            calc.find('#rashod').addClass('error');
        }
        if(!layout){
            error += '<div>Заполните поле Кол-во слоев</div>';
            calc.find('#layout').addClass('error');
        }
        if(!volume){
            error += '<div>Заполните поле Объем тары</div>';
            calc.find('#volume').addClass('error');
        }
        if(length1 && !width1){
            error += '<div>Заполните поле Ширина</div>';
            calc.find('#width1').addClass('error');
        }
        if(!length1 && width1){
            error += '<div>Заполните поле Длина</div>';
            calc.find('#length1').addClass('error');
        }

        if(error){
            block_error.html(error);
        }

        if(length && width && rashod && layout && volume){
            sq = length * width;
            if(length1 && width1){
                sq_ex = length1 * width1;
            }
            sq = sq - sq_ex;
            console.log(sq, rashod, layout, volume)
            if(sq<=0 || rashod==0 || layout==0 || volume==0){
                error = 'Проверьте корректность данных';
                block_error.html(error);
            }else{
                result += '<div class="line-result"><span>Площадь окраски, кв. м:</span> '+ sq +'</div>';

                if(add == 2){
                    coeff = 1;
                }else if(add == 3){
                    coeff = 2;
                }

                count_paint = ((Math.ceil((sq/rashod)*100)/100)*layout*(1 + 0.05*coeff)).toFixed(2);

                result += '<div class="line-result"><span>Количество краски, кг:</span> '+ (Math.ceil(count_paint * 100)/100) +'</div>';
                result += '<div class="line-result"><span>Количество банок:</span> '+ Math.ceil(count_paint / volume) +'</div>';

                if(!isInteger(count_paint / volume)){
                    let no_use_point = (Math.ceil(count_paint / volume) * volume - Math.ceil(count_paint * 100)/100).toFixed(2);
                    result += '<div class="line-result"><span>Неиспользуемая краска, кг:</span> '+ Math.ceil(no_use_point * 100)/100 +'</div>';
                }

                block_result.html(result);
            }
        }
    });
}

let $poroductSlider = $(".swiper-container.product__pictures-slider");
let heightProductSlider = $poroductSlider.height();
let widthProductSlider = $poroductSlider.width();

$(document).ready(function (){
    if($(".slide-video").length > 0){
        let sliderProduct = document.querySelector('.product__pictures-slider').swiper;
        sliderProduct.slideNext();
    }
});

$(".slide-video").click(function (){
    $(".iframe.lazy").each(function (){
        let htmlEframe = $(this).html();
        let htmlIframe = htmlEframe.replace("eframe", "iframe");
        $(this).html(htmlIframe);
        $(this).removeClass("lazy");
    });
    $(".swiper-slide.product__pictures-thumb iframe").attr("height", 400).attr("width", widthProductSlider);

});

// замена изображений
let replaceImage = new ReplacerImage('.colors-options .euv-custom-select__option',
    '.euv-custom-select__option',
    '.product__picture .product__pictures-image',
    '.euv-custom-select__options-wrap');

